export default function TrustBar() {
  const items = [
    { icon: "ri-shield-check-line", text: "No clinic affiliations" },
    { icon: "ri-file-search-line", text: "Research-backed guides" },
    { icon: "ri-coins-line", text: "Real cost comparisons" },
    { icon: "ri-global-line", text: "Covering 4 top destinations" },
    { icon: "ri-heart-pulse-line", text: "Safety-first approach" },
  ];

  return (
    <div className="bg-[#182940] border-t border-white/10">
      <div className="w-full px-4 md:px-6 lg:px-8 py-4 md:py-5">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {items.map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-sm text-white/60">
              <span className="w-5 h-5 flex items-center justify-center text-primary-400">
                <i className={item.icon}></i>
              </span>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}